import moment from 'moment';
import React, { useState, useMemo } from 'react';
import BootstrapTable from 'react-bootstrap-table-next';
import filterFactory, { selectFilter } from "react-bootstrap-table2-filter";
import ToolkitProvider from 'react-bootstrap-table2-toolkit';
import {
  Card,
  CardBody,
  Modal,
  ModalBody,
  ModalHeader,
  Badge,
} from 'reactstrap';
import { postSubmitForm } from '../../../helpers/forms_helper';
import { withNamespaces } from 'react-i18next';
import preloader from '../../../helpers/preloader';
import { Link } from 'react-router-dom/cjs/react-router-dom.min';

const AllDrafts = ({
  isOpen,
  toggle,
  title = 'Data Table',
  data = [],
  keyField = '_id',
  selectRow = {},
  noDataMessage = 'No data to display.',
  enableSearch = true,
  t,
  onDelete,
  showSupplierColumn,
  storeType
}) => {
  const [expandedGroups, setExpandedGroups] = useState({});

  const groupedData = useMemo(() => {
    const groups = {};
    
    data.forEach(item => {
      const username = item.createdBy?.username || 'Unknown User';
      if (!groups[username]) {
        groups[username] = {
          username,
          userInfo: item.createdBy,
          items: [],
          totalItems: 0,
          statuses: new Set()
        };
      }
      groups[username].items.push(item);
      groups[username].totalItems++;
      groups[username].statuses.add(item.status);
    });
    
    return Object.values(groups);
    //   const flattenedData = [];
    // Object.values(groups).forEach(group => {
    //   flattenedData.push({ ...group, isGroupHeader: true, id: group.username }); // Add group header marker
    //   group.items.forEach(item => flattenedData.push(item));
    // });

    // return flattenedData;
  }, [data]);

  const toggleGroup = (username) => {
    setExpandedGroups(prev => {
      const isOpen = !!prev[username];
      return isOpen
        ? {}
        : { [username]: true };
    });
  };
  function dynamicSort(property) {
    var sortOrder = 1;
    if (property[0] === "-") {
      sortOrder = -1;
      property = property.substr(1);
    }
    return function (a, b) {
      var result =
        a[property] < b[property] ? -1 : a[property] > b[property] ? 1 : 0;
      return result * sortOrder;
    };
  }

  const handleDeleteDraft = async (row) => {
    try {
      preloader(true)
      let url = "";
      if(storeType === "Central Kitchen"){
        url =process.env.REACT_APP_BASEURL +"productpurchaseorderdrafts/delete_draft"
      }else{
       url =  process.env.REACT_APP_BASEURL + "po_draft/delete_draft";
      }
      let response = await postSubmitForm(url, {draft_id: row._id});
      if (response.status === 1) {
        onDelete();
      }
    } catch (error) {
      console.log(error);
    } finally {
      preloader(false)
    }
  };

  const branchColumns = [
    {
      dataField: "_id",
      hidden: true,
    },
    {
      text: t("#"),
      dataField: "_id",
      formatter: (cell, row, rowIndex) => rowIndex + 1,
      sort: false,
      headerStyle: () => ({ width: "8%" }),
    },
    {
      text: t("Store/Branch Name"),
      dataField: "branch_details.name",
      sort: true,
      filter: selectFilter({
        options: (() => {
          const unique = [
            ...new Map(
              [
                ...new Set(
                  data?.map(({ branch_details }) => ({
                    value: branch_details?.name,
                    label: branch_details?.name,
                  }))
                ),
              ].map((item) => [item["value"], item])
            ).values(),
          ];
          unique.sort(dynamicSort("label"));
          return unique;
        })(),
      }),
       filterRenderer: (filterProps) => (
    <div style={{ minWidth: 120, maxWidth: 180 }}>
      {filterProps}
    </div>
  ),
    },
    {
      text: (() => {
        switch (storeType) {
          case "Sub Store":
          case "Central Store":
          case "Central Kitchen":
          case "Main Store":
            return t("Deliver at Store");
          case "Branch":
          default:
            return t("Deliver at Branch");
        }
      })(),
      sort: true,
      hidden:storeType === "Central Kitchen",
      formatter: (cell, row) => {
        switch (row.branch_details?.type) {
          case "Branch":
            return row.deliver_at_branch ? "Yes" : "No";
          case "Main Store":
            return row.deliver_at_mainstore ? "Yes" : "No";
          case "Sub Store":
            return row.deliver_at_substore ? "Yes" : "No";
          default:
            return "";
        }
      },
    },
    {
      text: t("Status"),
      dataField: "status",
      sort: true,
      headerStyle: () => ({ width: "15%" }),
      formatter: (cell) => (
        <Badge 
          color={cell === 'Draft' ? 'warning' : 'primary'} 
          className="px-2 py-1"
        >
          {cell}
        </Badge>
      )
    },
    {
      dataField: "createdAt",
      text: t("Date"),
      formatter: (cell, row) => {
           return  moment(row.createdAt).format("YYYY-MM-DD HH:mm")
    },
      sort: true,
    },
    {
      dataField: "",
      editable: false,
      text: "Action",
      formatter: (cell, row) => (
        <>
        <div  className="d-flex justify-content-center">
<span className="d-flex justify-content-center text-danger mr-2">
          <i
            className="bx bxs-trash font-size-20 hover:text-danger"
            title="Click to Remove"
            style={{ cursor: "pointer", transition: 'all 0.2s' }}
            onClick={(e) => {
              e.stopPropagation();
              handleDeleteDraft(row);
            }}
          ></i>
        </span>
        <span className="d-flex justify-content-center text-dark">
          <i
            className="bx bxs-printer font-size-20 hover:text-dark"
            title="Click to Print"
            style={{ cursor: "pointer", transition: 'all 0.2s' }}
            onClick={(e) => {
              e.stopPropagation();
              handlePrintBranch(row)            
            }}
          ></i>
        </span>
        </div>
        </>
      ),
      headerStyle: () => ({ width: "10%" }),
      sort: false,
      classes: "d-print-none",
      footer: false,
    },
  ];

  const supplierColumns = [
    {
      dataField: "_id",
      hidden: true,
    },
    {
      text: t("#"),
      dataField: "_id",
      formatter: (cell, row, rowIndex) => rowIndex + 1,
      sort: false,
      headerStyle: () => ({ width: "8%" }),
    },
    {
      text: t("Supplier Name"),
      dataField: "supplier.name",
      sort: true,
      headerStyle: () => ({ width: "18%" }),
      filter: selectFilter({
        options: (() => {
          const unique = [
            ...new Map(
              data?.map(({ supplier }) => ({
                value: supplier?.name,
                label: supplier?.name,
              }))
                .filter(Boolean)
                .map((item) => [item.value, item])
            ).values(),
          ];
          unique.sort(dynamicSort("label"));
          return unique;
        })(),
        placeholder: "All"
      }),
    },
    {
      text: t("Supplier Mobile"),
      dataField: "supplier.mobile",
      sort: true,
      headerStyle: () => ({ width: "15%" }),
    },
    {
      text: t("Status"),
      dataField: "status",
      sort: true,
      headerStyle: () => ({ width: "15%" }),
      formatter: (cell) => (
        <Badge 
          color={cell === 'Draft' ? 'warning' : 'primary'} 
          className="px-2 py-1"
        >
          {cell}
        </Badge>
      )
    },
    {
      dataField: "createdAt",
      text: t("Date"),
      formatter: (cell, row) => {
           return  moment(row.createdAt).format("YYYY-MM-DD HH:mm")
    },
      sort: true,
    },
    {
      dataField: "",
      editable: false,
      text: "Action",
      formatter: (cell, row) => (
        <>
        <div  className="d-flex justify-content-center">
<span className="d-flex justify-content-center text-danger mr-2">
          <i
            className="bx bxs-trash font-size-20 hover:text-danger"
            title="Click to Remove"
            style={{ cursor: "pointer", transition: 'all 0.2s' }}
            onClick={(e) => {
              e.stopPropagation();
              handleDeleteDraft(row);
            }}
          ></i>
        </span>
        <span className="d-flex justify-content-center text-dark">
          <i
            className="bx bxs-printer font-size-20 hover:text-dark"
            title="Click to Print"
            style={{ cursor: "pointer", transition: 'all 0.2s' }}
            onClick={(e) => {
              e.stopPropagation();
              handlePrintSupplierDraft(row)             
            }}
          ></i>
        </span>
        </div>
        </>
      ),
      headerStyle: () => ({ width: "10%" }),
      sort: false,
    },
  ];

  const getRoleColor = (role) => {
    const colors = {
      'Branch Supervisor': 'primary',
      'Sub Store Manager': 'success',
      'Equipment Store Manager': 'info',
      'Main Store Manager': 'warning',
      'Central Store Manager': 'secondary'
    };
    return colors[role] || 'dark';
  };
  
  function printDiv(divName) {
    let printContents = document.getElementById(divName);
    let searchelement = printContents.getElementsByClassName("sr-only");
    if (searchelement && searchelement[0]?.parentNode) {
      searchelement[0].parentNode.removeChild(searchelement[0]);
    }
    var winPrint = window.open(
      "",
      "",
      "left=0,top=0,toolbar=0,scrollbars=0,status=0"
    );
    // winPrint.document.body.innerHTML = printContents;
    // <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.0/dist/css/bootstrap.min.css">
    winPrint.document.write(
      `<title>${divName} Report</title>
      <head>
       <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.0/dist/css/bootstrap.min.css">

        <style>
          @page {
        margin: 4mm;
      }
      
      body {
        margin: 4mm;
      } 
         /* Hide react-bootstrap-table controls */
           .sr-only,
      .react-bootstrap-table-pagination,
      .react-bootstrap-table-filter-wrapper,
      .search-label,
      .select-filter,
      .custom-select,
      [class*="toolbar"],
      .react-bootstrap-table-pagination-list,
      .react-bootstrap-table-pagination-total,
      .text-filter,
      .text-filter-column,
      .filter-label,
      [class*="filter"],
      .react-bootstrap-table-search,
      .react-bootstrap-table-search-input {
        display: none !important;
      }
          
          /* Hide search box */
          .react-bootstrap-table-search-input,
          .react-bootstrap-table-search,
          .search-bar {
            display: none !important;
          }
          
          /* Remove extra padding/margins from table */
          .react-bootstrap-table {
            margin: 0 !important;
            padding: 0 !important;
          }
      
          /* Ensure table takes full width */
          .table-responsive {
            width: 100% !important;
            margin: 0 !important;
            padding: 0 !important;
          }

          
  .table-container select,
  .table-container .filter-select,
  .react-bootstrap-table-filter-wrapper,
  .react-bootstrap-table-search,
  .react-bootstrap-table-search-input,
  .react-bootstrap-table-pagination,
  .react-bootstrap-table-pagination-list,
  .react-bootstrap-table-pagination-total,
  .text-filter,
  .text-filter-column,
  .filter-label,
  [class*="filter"],
  [class*="toolbar"] {
    display: none !important;
  }
    /* Hide first and last column */
        table th:first-child,
        table td:first-child,
        table th:last-child,
        table td:last-child {
          display: none;
        }
         
        </style>
      </head>
      <body>
        ${printContents.innerHTML}
      </body>
      `
    );
    winPrint.document.close();
    winPrint.focus();
    winPrint.print();
    //winPrint.close();
  }
const handlePrintBranch = (row) => {  
  const width = 900;
  const height = 700;
  const left = window.screenX + 50;
  const top = window.screenY + 50;
  const uniqueWindowName = `print_branch_${row._id}`;

  // Open new window with custom URL and features
  const printWindow = window.open(
    `/print_branch_details?branch_id=${row._id}`,
    uniqueWindowName,
    `width=${width},height=${height},top=${top},left=${left},toolbar=no,location=no,directories=no,status=no,menubar=no,scrollbars=yes,resizable=yes`
  );

  // Write details into the new window
  if (printWindow) {
    const branch = row.branch_details || row.branch || {};
    const items = storeType === "Central Kitchen" ? (row.products || []) :(row.items || []);
  
    // Generate category tables HTML
    const categoryTablesHTML = items?.map((item,index) => `
      <div class="category-section">
      <div class="category-header">
      <div class="category-col">
        <h5 class="category-title">${item?.category}</h5>
      </div>
      <div class="supplier-col">
        <div class="supplier-info">
          <strong>Supplier: ${item?.supplier?.name || 'N/A'}</strong>
        </div>
      </div>
    </div>
           

        <table class="table table-striped table-bordered">
          <thead>
            <tr>
              <th style="width: 5%">#</th>
              <th style="width: 25%">Name</th>
              <th style="width: 15%">Sub Category</th>
              <th style="width: 12%">Brand</th>
              <th style="width: 10%">Unit</th>
              <th style="width: 10%">Price</th>
              <th style="width: 13%">Quantity</th>
              <th style="width: 10%">Total</th>
            </tr>
          </thead>
          <tbody>
            ${item?.items?.map((item, idx) => `
              <tr>
                <td>${idx + 1}</td>
                <td>${item.name || ""}</td>
                <td>${item.sub_category || ""}</td>
                <td>${item.brand || ""}</td>
                <td>${item.unit_for_po || item.unit || ""}</td>
                <td>${item.price || ""}</td>
                <td>${item.quantity?.map(q => `${q.value} ${q.unit}`).join(", ") || item.quantity || ""}</td>
                <td>${item.total_price || ""}</td>
              </tr>
            `).join("")}
          </tbody>
        </table>
      </div>
    `).join("");

     const productsTablesHTML = `
      <div class="category-section">
        <table class="table table-striped table-bordered">
          <thead>
            <tr>
              <th style="width: 5%">#</th>
              <th style="width: 25%">Name</th>
              <th style="width: 15%">Section</th>
              <th style="width: 12%">Category</th>
              <th style="width: 10%">Purchasing Unit</th>
              <th style="width: 10%">Price</th>
              <th style="width: 13%">Quantity</th>
              <th style="width: 10%">Total</th>
            </tr>
          </thead>
          <tbody>
            ${items?.map((item, idx) => `
              <tr>
                <td>${idx + 1}</td>
                <td>${item.name || ""}</td>
                <td>${item.section || ""}</td>
                <td>${item.category || ""}</td>
                <td>${item.unit_for_cost_price || ""}</td>
                <td>${item.price || ""}</td>
                <td>${item.quantity?.map(q => `${q.value} ${q.unit}`).join(", ") || item.quantity || ""}</td>
                <td>${item.total_price || ""}</td>
              </tr>
            `).join("")}
          </tbody>
        </table>
      </div>`

    printWindow.document.write(`
      <html>
        <head>
          <title>Purchase Order Draft Details</title>
          <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.0/dist/css/bootstrap.min.css">
          <style>
            body { 
              margin: 20px; 
              font-family: 'Inter', Arial, sans-serif; 
              font-size: 12px;
            }
            h2 { 
              color: #007bff; 
              font-size: 18px;
              margin-bottom: 16px;
            }
              .category-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
}

.category-col, .supplier-col {
  width: 50%;
}

.category-col h5 {
  margin: 0;
}

.supplier-info {
  text-align: right;
}

            h5.category-title { 
              font-size: 14px;
              margin-top: 25px;
              margin-bottom: 10px;
              color: #495057;
              background-color: #e9ecef;
              padding: 8px 12px;
              border-radius: 4px;
              border-left: 4px solid #007bff;
            }
            .header-info {
              display: flex;
              justify-content: space-between;
              align-items: center;
              margin-bottom: 20px;
              padding: 12px;
              background-color: #f8f9fa;
              border-radius: 4px;
            }
            .branch-name {
              font-weight: bold;
              font-size: 14px;
            }
            .created-info {
              text-align: right;
              font-size: 11px;
              color: #666;
            }
            .category-section {
              margin-bottom: 25px;
              page-break-inside: avoid;
            }
            .table { 
              font-size: 11px;
              margin-top: 10px; 
            }
            .table th {
              background-color: #f8f9fa;
              font-size: 10px;
              padding: 6px;
              font-weight: 600;
            }
            .table td {
              padding: 6px;
            }
            .table tbody tr:nth-child(odd) {
              background-color: #f8f9fa;
            }
            @media print {
              body { font-size: 10px; }
              .header-info { font-size: 11px; }
              .table { font-size: 9px; }
              .table th, .table td { padding: 4px; }
              .category-section { page-break-inside: avoid; }
              h5.category-title { font-size: 12px; }
            }
          </style>
        </head>
        <body>
          <h2>Purchase Order Draft Details</h2>
          
          <div class="header-info">
            <div class="branch-name">
              Store/Branch: ${branch.name || row.name || "N/A"}
            </div>
            <div class="created-info">
              <div>Created By: ${row.createdBy?.username || "N/A"}</div>
              <div>Date: ${moment(row.createdAt).format("YYYY-MM-DD HH:mm")}</div>
            </div>
          </div>

          ${storeType === "Central Kitchen" ? productsTablesHTML : categoryTablesHTML || '<p>No items found</p>'}
        </body>
      </html>
    `);
    printWindow.document.close();
    printWindow.focus();
    setTimeout(() => printWindow.print(), 500);
  }
};
const handlePrintSupplierDraft = (row) => {
  const width = 900;
  const height = 700;
  const left = window.screenX + 50;
  const top = window.screenY + 50;
  const uniqueWindowName = `print_${row._id}`;

  // Open new window with custom URL and features
  const printWindow = window.open(
    `/print_details?emp_id=${row._id}`,
    uniqueWindowName,
    `width=${width},height=${height},top=${top},left=${left},toolbar=no,location=no,directories=no,status=no,menubar=no,scrollbars=yes,resizable=yes`
  );

  // Write details into the new window
  if (printWindow) {
    const supplier = row.supplier || {};
    const items = row.items || [];

    printWindow.document.write(`
      <html>
        <head>
          <title>Purchase Order Draft Details</title>
          <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.0/dist/css/bootstrap.min.css">
          <style>
            body { 
              margin: 20px; 
              font-family: 'Inter', Arial, sans-serif; 
              font-size: 12px;
            }
            h2 { 
              color: #007bff; 
              font-size: 18px;
              margin-bottom: 16px;
            }
            h4 { 
              font-size: 14px;
              margin-top: 20px;
              margin-bottom: 10px;
            }
            .header-info {
              display: flex;
              justify-content: space-between;
              align-items: center;
              margin-bottom: 20px;
              padding: 12px;
              background-color: #f8f9fa;
              border-radius: 4px;
            }
            .supplier-name {
              font-weight: bold;
              font-size: 14px;
            }
            .created-info {
              text-align: right;
              font-size: 11px;
              color: #666;
            }
            .table { 
              font-size: 11px;
              margin-top: 10px; 
            }
            .table th {
              background-color: #f8f9fa;
              font-size: 10px;
              padding: 6px;
            }
            .table td {
              padding: 6px;
            }
            @media print {
              body { font-size: 10px; }
              .header-info { font-size: 11px; }
              .table { font-size: 9px; }
              .table th, .table td { padding: 4px; }
            }
          </style>
        </head>
        <body>
          <h2>Purchase Order Draft Details</h2>
          
          <div class="header-info">
            <div class="supplier-name">
              Supplier: ${supplier.name || "N/A"}
            </div>
            <div class="created-info">
              <div>Created By: ${row.createdBy?.username || "N/A"}</div>
              <div>Date: ${moment(row.createdAt).format("YYYY-MM-DD HH:mm")}</div>
            </div>
          </div>

          <h4>Items</h4>
          <table class="table table-striped table-bordered">
            <thead>
              <tr>
                <th style="width: 5%">#</th>
                <th style="width: 20%">Name</th>
                <th style="width: 15%">Category</th>
                <th style="width: 15%">Sub Category</th>
                <th style="width: 10%">Brand</th>
                <th style="width: 8%">Unit</th>
                <th style="width: 10%">Price</th>
                <th style="width: 12%">Quantity</th>
                <th style="width: 10%">Total</th>
              </tr>
            </thead>
            <tbody>
              ${items.map((item, idx) => `
                <tr>
                  <td>${idx + 1}</td>
                  <td>${item.name || ""}</td>
                  <td>${item.category || ""}</td>
                  <td>${item.sub_category || ""}</td>
                  <td>${item.brand || ""}</td>
                  <td>${item.unit_for_po || ""}</td>
                  <td>${item.price || ""}</td>
                  <td>${item.quantity?.map(q => `${q.value} ${q.unit}`).join(", ") || ""}</td>
                  <td>${item.total_price || ""}</td>
                </tr>
              `).join("")}
            </tbody>
          </table>
        </body>
      </html>
    `);
    printWindow.document.close();
    printWindow.focus();
    setTimeout(() => printWindow.print(), 500);
  }
};
  return (
    <Modal size="xl" isOpen={isOpen} toggle={toggle}>
      <ModalHeader toggle={toggle} >
        <div className="d-flex align-items-center">
          <i className="bx bx-table mr-2 text-primary"></i>
          {title}
                    {/* <Link
                        to="#"
                        onClick={() => {
                          printDiv("printDiv");
                        }}
                        className="btn btn-sm btn-success ml-3"
                      >
                        <i className="fa fa-print"></i> Print
                      </Link> */}
        </div>
        
      </ModalHeader>
      <ModalBody >
        <Card className="border-0">
          <CardBody className="p-0">
            <div id='printDiv'>
            {groupedData.length === 0 ? (
              <div className="text-center py-5">
                <i className="bx bx-folder-open font-size-48 text-muted mb-3"></i>
                <p className="text-muted">{noDataMessage}</p>
              </div>
            ) : (
              <div className="grouped-table-container">
                {groupedData.map((group, groupIndex) => (
                  <div key={group.username} className="mb-3">
                    {/* Group Header */}
                    <div 
                      className="group-header bg-light p-3 cursor-pointer border-bottom"
                      onClick={() => toggleGroup(group.username)}
                      style={{
                        cursor: 'pointer',
                        transition: 'all 0.3s ease',
                        borderLeft: '4px solid #007bff'
                      }}
                    >
                      <div className="d-flex align-items-center justify-content-between">
                        <div className="d-flex align-items-center">
                          {/* <i 
                            className={`bx ${expandedGroups[group.username] ? 'bx-chevron-down' : 'bx-chevron-right'} 
                                       mr-2 font-size-16 transition-all`}
                          ></i> */}
                          
                          {/* User Avatar */}
                          <div className="user-avatar mr-3">
                            <div className="bg-primary rounded-circle d-flex align-items-center justify-content-center" 
                                 style={{width: '40px', height: '40px'}}>
                              <span className="text-white font-weight-bold">
                                {group.userInfo?.role?.charAt(0) || 'U'}
                              </span>
                            </div>
                          </div>
                          
                          {/* User Info */}
                          <div>
                            <h6 className="mb-1 font-weight-bold text-dark">
                              {group.userInfo?.role || 'Unknown User'}
                            </h6>
                            <div className="d-flex align-items-center text-muted">
                              <Badge color={getRoleColor(group.userInfo?.role)} className="mr-2 px-2">
                                {group.userInfo?.username || 'N/A'}
                              </Badge>
                            </div>
                          </div>
                        </div>
                        
                        {/* Group Stats */}
                        <div className="d-flex align-items-center">
                          <div className="text-center mr-3">
                            <div className="font-weight-bold text-primary h5 mb-0">
                              {group.totalItems}
                            </div>
                            <small className="text-muted">Drafts</small>
                          </div>
                          
                        </div>
                      </div>
                    </div>

                    {/* <Collapse isOpen={expandedGroups[group.username]}> */}
                      <div className="table-container m-1" style={{maxHeight: '400px', overflow: 'auto'}}>
                        <ToolkitProvider
                          bootstrap4
                          keyField={keyField}
                          data={group.items}
                          columns={showSupplierColumn ? supplierColumns : branchColumns}
                          noDataIndication={noDataMessage}
                          search={enableSearch}
                        >
                          {(toolkitProps) => (
                            <div>
                              <BootstrapTable
                                striped
                                hover
                                condensed
                                filter={filterFactory()}
                                selectRow={selectRow}
                                classes="table-sm"
                                wrapperClasses="table-responsive"
                                {...toolkitProps.baseProps}
                              />
                            </div>
                          )}
                        </ToolkitProvider>
                      </div>
                    {/* </Collapse> */}
                  </div>
                ))}
              </div>
            )}
            </div>
          </CardBody>
        </Card>
      </ModalBody>
     <style jsx>
      {`
      .table-container .filter-select,
.table-container select {
  min-width: 120px;
  max-width: 180px;
  font-size: 0.95rem;
  padding: 2px 8px;
  margin: 0;
}
.group-header-row {
  background-color: #f2f2f2; /* Light grey background */
  font-weight: bold;
  cursor: pointer;
  
}
.group-header-row td {
  padding: 0 !important; /* Remove padding for the entire row */
}
      `}
      </style>       
    </Modal>
  );
};

export default withNamespaces()(AllDrafts);